import { Autorenew } from '@material-ui/icons'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useRecordContext,
  useRefresh,
  useShowContext,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { TerminalUploadPackDialog } from '../TerminalDialogs'
import { TerminalDto } from '../../../../core/dto/device/terminals/terminal.dto'

export const TerminalUploadPackButton = ({ ...props }) => {
  const { asRecurringJob, ...rest } = props
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { loading } = useShowContext()
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false)
  const [packId, setPackId] = useState(0)
  const terminal = useRecordContext<TerminalDto>()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  const onClick = async () => {
    setUploadDialogOpen(true)
  }

  const handleUploadPack = async (
    recurringJobName?: string,
    cronExpression?: string,
  ) => {
    await mutate(
      {
        type: sanitizeFetchType('uploadPack'),
        resource: ResourceName.TERMINALS,
        payload: {
          terminalId: terminal?.id,
          mediaPackId: packId,
          recurringJobName,
          cronExpression,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    refresh()
  }

  return (
    <>
      <TerminalUploadPackDialog
        open={uploadDialogOpen}
        close={() => setUploadDialogOpen(false)}
        packId={packId}
        setPackId={setPackId}
        handleUploadPack={handleUploadPack}
        asRecurringJob={asRecurringJob}
      />
      <Button
        variant="contained"
        color="primary"
        label={!asRecurringJob ? 'resources.terminals.actions.upload-pack' : ''}
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.TERMINALS_UPLOAD_PACK_BUTTON) ||
          loading ||
          mutationLoading
        }
        onClick={onClick}
        size="small"
        {...rest}
      >
        {asRecurringJob ? <Autorenew /> : undefined}
      </Button>
    </>
  )
}
